import { PTag } from "@porsche-design-system/components-react"
import type { PIconProps } from "@porsche-design-system/components-react"
import { FormattedMessage } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"

interface NewBadgeProps {
	compact?: boolean
	icon?: PIconProps["name"]
}

export const NewBadge = ({ compact, ...props }: NewBadgeProps) => {
	return (
		<PTag {...props} variant="info" compact={compact}>
			<FormattedMessage {...commonMessages.new} />
		</PTag>
	)
}
